<template>
  <div id="app">
    <!-- 路由占位符 -->
    <router-view ></router-view>
    <div v-if="footerShow">
        <Footer :routerPath="routerPath"></Footer>
    </div>
  </div>
</template>

<script>
import Footer from "./views/Footer.vue";

export default {
   data() {
    return {
      footerShow: true,
      routerPath:'',
    }
   },
  components: {
    Footer,
  },
  watch: {
       $route(to, from) {
      if (this.$route.path == "/advertising" ) {
        this.footerShow = false;
      } else {
        this.footerShow = true;
        this.routerPath=this.$route.path
      }
    },

  },
  methods: {
    getQueryVariable() {
      // 获得了当前链接的中?号后的参数,location.search的值就是 '?xxx=xxx ' ,substr(1)就是从索引1开始截取
      var url = window.location.href;
      var urlItem = url.split("#")[1];
      sessionStorage.setItem("href", url);
      sessionStorage.setItem("hrefItem", urlItem);
    },
  },
  created() {
    this.getQueryVariable();
    this.$nextTick(() => {
      // 禁用右键
      // document.oncontextmenu = new Function("event.returnValue=false");
      // 禁用选择
      // document.onselectstart = new Function("event.returnValue=false");
      // document.oncopy=new Function("event.returnValue=false");
    });
  },
};
</script>

<style>
.header {
  height: 90px;
}
/* // 搜索框 */
#kw {
  /* width: 512px; */
  width: 380px;
  height: 16px;
  padding: 10px 16px;
  font-size: 16px;
  margin: 0;
  vertical-align: top;
  outline: 0;
  box-shadow: none;
  border: 1px solid #c4c7ce;
  background: #fff;
  color: #222;
  overflow: hidden;
  box-sizing: content-box;
  margin-left: -2px;
  border-radius: 5px 0 0 5px;
}
#kw:focus {
  border: 1px solid #1f8bd0;
}
#su {
  cursor: pointer;
  width: 62px;
  height: 38px;
  line-height: 45px;
  line-height: 44px\9;
  padding: 0;
  background: 0 0;
  background-color: #1f8bd0;
  /* background-color: #000; */
  border-radius: 0 5px 5px 0;
  font-size: 17px;
  color: #fff;
  box-shadow: none;
  font-weight: 400;
  border: none;
  outline: 0;
  margin-left: -1px;
}
/* // 下拉菜单 */
.el-dropdown-menu__item {
  margin: 5px;
}
.dropdown_item span {
  color: #818181;
}

/* 悬浮图片放大 */
.effect-img {
  text-align: center;
  cursor: pointer;
  zoom: 1;
  overflow: hidden;
}

.effect-img img {
  opacity: 1;
  -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
  transition: opacity 0.35s, transform 0.35s;
  /* display: block; */
  width: 100%;
  height: 100%;
}

.effect-img:hover img {
  opacity: 1;
  -webkit-transform: scale3d(1.1, 1.1, 1);
  transform: scale3d(1.1, 1.1, 1);
}
.effect-img:hover .tit {
  color: #1f8bd0;
}

/* 获取验证码位置调整 */
.el-input__suffix-inner {
  padding-right: 10px;
}

/* 测试按钮 */
.testBtn {
  background-color: #1f8bd0 !important;
  border-color: #1f8bd0 !important;
  width: 198px !important;
  border-radius: 0 !important;
  font-size: 16px !important;
  transition: all 0.3s !important;
}
.testBtn:hover {
  transform: translateY(-3px);
  box-shadow: 0 2px 10px rgba(31, 139, 208, 0.7);
}
/* 预览弹窗 */
.PreviewArea .el-dialog {
  margin-top: 5vh !important;
}
</style>
